export const getRandomNumberBetween = (x, y) => (
  Math.floor(Math.random() * y) + x
);
